var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { getLanguageFromStorage } from 'syf-js-utilities';
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
import { useRewardsConfigContext } from '../../../../../context/rewardsConfig';
import getClientImgSrc from '../../../../../helpers/imageUtils';
import useRewards from '../../../../../hooks/useRewards';
import PropositionsCard from '../PropositionCard';
import Carousel from '../../../../../ui/molecules/Carousel';
import { CardsContainer, ClientImage, ClientImageContainer, TextContent, Title, ValuePropositionContainer } from './subcomponents';
var ValueProposition = function () {
    var _a, _b;
    var t = useTranslation().t;
    var language = getLanguageFromStorage();
    var config = useRewardsConfigContext().config;
    var isLessThanDesktop = useWindowSize().isLessThanDesktop;
    var _c = useRewards(), cardType = _c.cardType, clientId = _c.clientId, rewardsExperience = _c.rewardsExperience;
    var rewardsExperienceClient = rewardsExperience[clientId];
    if (!rewardsExperienceClient) {
        throw new Error("rewardsExperienceClient is undefined for clientId: ".concat(clientId));
    }
    var rewardsExperienceCard = rewardsExperienceClient[cardType];
    var howToEarnPointsHeader = rewardsExperienceClient.howToEarnPointsHeader;
    var valuePropImg = rewardsExperienceCard === null || rewardsExperienceCard === void 0 ? void 0 : rewardsExperienceCard.valuePropImg;
    var disclaimer = (_a = rewardsExperienceCard === null || rewardsExperienceCard === void 0 ? void 0 : rewardsExperienceCard[language]) === null || _a === void 0 ? void 0 : _a.disclaimer;
    var propositions = (_b = rewardsExperienceCard === null || rewardsExperienceCard === void 0 ? void 0 : rewardsExperienceCard[language]) === null || _b === void 0 ? void 0 : _b.propositions;
    var shouldShowCarousel = isLessThanDesktop && propositions.length > 2;
    var propCards = function () {
        if (!propositions || propositions.length === 0) {
            return null;
        }
        var lastIndex = propositions.length - 1;
        var isDivisibleByThree = propositions.length % 3 === 1;
        return propositions.map(function (element, index) {
            var isFullWidthProposition = index === lastIndex && isDivisibleByThree;
            return (_jsx(PropositionsCard, { heading: element.heading, points: element.points, description: element.description, isFullWidthProposition: isFullWidthProposition, dataCy: "val-prop-card-".concat(element.description) }, "val-prop-card-".concat(element.description)));
        });
    };
    return (_jsxs(ValuePropositionContainer, __assign({ "data-testid": "cards-value-proposition" }, { children: [_jsx(Title, __assign({ "data-cy": "val-prop-header" }, { children: t(howToEarnPointsHeader) })), _jsxs(CardsContainer, { children: [shouldShowCarousel ? (_jsx(Carousel, __assign({ dataCy: "val-prop-carousel", itemsToShow: propositions.length }, { children: propCards() }))) : (propCards()), valuePropImg && (_jsx(ClientImageContainer, { children: _jsx(ClientImage, { src: getClientImgSrc({
                                config: config,
                                client: clientId,
                                image: valuePropImg
                            }), alt: "".concat(clientId, " value proposition") }) }))] }), disclaimer && _jsx(TextContent, { children: disclaimer })] })));
};
export default ValueProposition;
